import $ from 'jquery';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Web from './components/pages/Web'
import reportWebVitals from './reportWebVitals';
// Amplify auth removed - not needed for static site
// import {Amplify} from 'aws-amplify';
// import aws_exports from './aws-exports';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
// Amplify.configure(aws_exports);
ReactDOM.render(
  <React.StrictMode>
    <Web/>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

